import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ overline, title, sub, align = "left" }) => (
  <div className={align === "center" ? "text-center mx-auto max-w-3xl" : "max-w-3xl"}>
    <Reveal>
      <p className="font-mono text-xs tracking-[0.3em] uppercase text-gold/90" data-testid={`overline-${overline?.toLowerCase().replace(/\s+/g, "-")}`}>
        {overline}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-normal tracking-tight text-neutral-100 leading-[1.12]">
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className="mt-5 text-base sm:text-lg font-light text-neutral-400 leading-relaxed">{sub}</p>
      </Reveal>
    )}
  </div>
);

export const GoldButton = ({ children, onClick, testId, className = "", type = "button" }) => (
  <motion.button
    type={type}
    data-testid={testId}
    onClick={onClick}
    whileHover={{ scale: 1.045 }}
    whileTap={{ scale: 0.96 }}
    transition={{ type: "spring", stiffness: 420, damping: 17 }}
    className={`btn-shine inline-flex items-center justify-center gap-2 rounded-full bg-leaf px-7 py-3.5 text-sm font-semibold tracking-wide text-void shadow-[0_10px_36px_-10px_rgba(232,193,90,0.55)] hover:bg-mint transition-colors duration-300 ${className}`}
  >
    {children}
  </motion.button>
);

export const GhostButton = ({ children, onClick, testId, className = "" }) => (
  <motion.button
    type="button"
    data-testid={testId}
    onClick={onClick}
    whileHover={{ scale: 1.045 }}
    whileTap={{ scale: 0.96 }}
    transition={{ type: "spring", stiffness: 420, damping: 17 }}
    className={`inline-flex items-center justify-center gap-2 rounded-full border border-white/20 px-7 py-3.5 text-sm font-medium tracking-wide text-neutral-200 hover:border-leaf/60 hover:text-mint transition-colors duration-300 ${className}`}
  >
    {children}
  </motion.button>
);
